import { useGlobal } from '@utmb/contexts/GlobalContext';
import { Font } from '@utmb/design-system/text/font';
import SliceExpandableCardsCollectionCardView from '@utmb/types/view/SliceExpandableCardsCollectionCardView';
import { parseMarkdown } from '@utmb/utils/markdown';
import { ReactElement } from 'react';
import styles from './expandable-cards-collection.module.scss';
import { useTranslation } from 'next-i18next';

export const ExpandableSlideContent = (props: SliceExpandableCardsCollectionCardView): ReactElement => {
    const { title, summary } = props;
    const { t } = useTranslation('common');

    const {
        global: {
            event: { primaryColorIsDark },
        },
    } = useGlobal();

    return (
        <div className={styles.slider_content_item}>
            {title && <Font.FuturaHeavy className={styles.content_title}>{title}</Font.FuturaHeavy>}
            {summary && (
                <Font.FuturaBook className={styles.content_summary} mobile="14" as="div">
                    <div
                        className={`markdown ${primaryColorIsDark ? 'primaryColorIsDark' : ''}`}
                        dangerouslySetInnerHTML={{ __html: parseMarkdown(summary) }}
                    />
                </Font.FuturaBook>
            )}
            <Font.FuturaBook mobile="14" className={[styles.content_link, 'font-underline', '-stretched-link'].join(' ')}>
                {t('promotionSlider.seeMore')}
            </Font.FuturaBook>
        </div>
    );
};
